<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click="onClick">
    <img src="~@/assets/img/CITEditor/outdent.svg" alt="text outdent" title="text outdent" />
  </button>
</template>

<script>
export default {
  name: 'TextOutdent',
  props: [
    'active'
  ],
  methods: {
    onClick () {
      document.execCommand('outdent', false)
    }
  }
}
</script>
